import React from 'react';
import { oneOf } from 'prop-types';
import { Helmet } from 'react-helmet-async';

/**
 * Sets the page's design family on <html> (`data-family`), which switches the design tokens in
 * marketplaceDefaults.css: public pages are orange, the dashboard is blue. It is on <html>, so
 * modals and menus rendered in #portal-root follow it, and the server renders it too. The deepest
 * one wins, so the dashboard shell overrides the one `Page` sets.
 */
const PageFamily = props => {
  const { family } = props;
  return <Helmet htmlAttributes={{ 'data-family': family }} />;
};

PageFamily.defaultProps = { family: 'public' };

PageFamily.propTypes = { family: oneOf(['public', 'dashboard']) };

export default PageFamily;
